export async function validateUser(user) {
    if (!user) {
        throw new Error(`No user provided`);
    }
    let claims = await getClaims(user);
    if (claims.superAdmin)
        return claims;
    if (!claims.companyId) {
        // alert("User has no CompanyId, please contact an administrator");
        throw new Error(`NoCompanyId`);
    }
    if (!claims.userType) {
        // alert("User has no UserType, please contact an administrator");
        throw new Error(`NoUserType`);
    }
    return claims;
}
export async function getClaims(user) {
    console.log(`getClaims() for User ${user.uid}:`, user);
    var { claims } = await user.getIdTokenResult();
    console.log("Claims:", claims);
    return claims;
}
//# sourceMappingURL=user-util.js.map